import "chartkick/chart.js"
import Chart from 'chart.js/auto'
import 'flatpickr/dist/flatpickr.min.css'
import flatpickr from 'flatpickr'

document.addEventListener('turbo:load', () => {
  flatpickr("[data-behavior='flatpickr']", {
    mode: 'range',
    altInput: true,
    altFormat: 'j F, Y',
    dateFormat: 'Y-m-d',
    weekNumbers: true,
  })
})

// Keep references to charts to avoid reusing canvases between Turbo visits
const charts = {};

function destroyIfExists(key){
  if (charts[key] && typeof charts[key].destroy === 'function') {
    try { charts[key].destroy(); } catch(e) {}
    charts[key] = null;
  }
}

document.addEventListener('turbo:load', () => {
  var el = document.getElementById('myChart2');
  if (!el) return;
  destroyIfExists('myChart2');
  var ctx = el.getContext('2d');
  charts['myChart2'] = new Chart(ctx, {
  type: 'bar',
  data: {
    labels: JSON.parse(ctx.canvas.dataset.labels),
    datasets: [{
      label: ctx.canvas.dataset.title,
      data: JSON.parse(ctx.canvas.dataset.data),
      fill: false,
      backgroundColor: 'rgba(75, 192, 192, 0.8)',
      tension: 0.1,
    }]
  },
    options: {
    scales: {
      y: {
        beginAtZero: true
      }
    }
  },

  });
})
document.addEventListener('turbo:load', () => {
  var el = document.getElementById('myVisitors');
  if (!el) return;
  destroyIfExists('myVisitors');
  var ctx = el.getContext('2d');
  charts['myVisitors'] = new Chart(ctx, {
  type: 'line',
  data: {
    labels: JSON.parse(ctx.canvas.dataset.labels),
    datasets: [{
      label: ctx.canvas.dataset.title,
      data: JSON.parse(ctx.canvas.dataset.data),
      fill: true,
      backgroundColor: 'rgba(245, 110, 71, 0.8)',
      tension: 0.3,
      pointStyle: 'circle',
      pointRadius: 10,
      pointHoverRadius: 15
    }]
  },

  });
})

document.addEventListener('turbo:load', () => {
  var el = document.getElementById('myChart');
  if (!el) return;
  destroyIfExists('myChart');
  var ctx = el.getContext('2d');
  charts['myChart'] = new Chart(ctx, {
  type: 'line',
  data: {
    labels: JSON.parse(ctx.canvas.dataset.labels),
    datasets: [{
      label: ctx.canvas.dataset.title,
      data: JSON.parse(ctx.canvas.dataset.data),
      fill: true,
      backgroundColor: 'rgba(245, 110, 71, 0.8)',
      tension: 0.3,
      pointStyle: 'circle',
      pointRadius: 10,
      pointHoverRadius: 15
    }]
  },

  });
})

document.addEventListener('turbo:load', () => {
  var el = document.getElementById('myChart3');
  if (!el) return;
  destroyIfExists('myChart3');
  var ctx = el.getContext('2d');
  charts['myChart3'] = new Chart(ctx, {
  type: 'line',
  data: {
    labels: JSON.parse(ctx.canvas.dataset.labels),
    datasets: [{
      label: ctx.canvas.dataset.title,
      data: JSON.parse(ctx.canvas.dataset.data),
      fill: true,
      backgroundColor: 'rgba(222, 170, 111, 0.8)',
      tension: 0.3,
      pointStyle: 'circle',
      pointRadius: 10,
      pointHoverRadius: 15
    }]
  },

  });
})

document.addEventListener('turbo:load', () => {
  var el = document.getElementById('myBlogs');
  if (!el) return;
  destroyIfExists('myBlogs');
  var ctx = el.getContext('2d');
  charts['myBlogs'] = new Chart(ctx, {
  type: 'bar',
  data: {
    labels: JSON.parse(ctx.canvas.dataset.labels),
    datasets: [{
      label: ctx.canvas.dataset.title,
      data: JSON.parse(ctx.canvas.dataset.data),
      fill: false,
      backgroundColor: 'rgba(222, 170, 111, 0.8)',
      tension: 0.1,
      pointStyle: 'circle',
      pointRadius: 10,
      pointHoverRadius: 15
    }]
  },options: {
    indexAxis: 'y',
  }

  });
})

document.addEventListener('turbo:load', () => {
  var el = document.getElementById('myReferrer');
  if (!el) return;
  destroyIfExists('myReferrer');
  var ctx = el.getContext('2d');
  charts['myReferrer'] = new Chart(ctx, {
  type: 'bar',
  data: {
    labels: JSON.parse(ctx.canvas.dataset.labels),
    datasets: [{
      label: ctx.canvas.dataset.title,
      data: JSON.parse(ctx.canvas.dataset.data),
      fill: true,
      backgroundColor: 'rgba(245, 110, 71, 0.8)',
      tension: 0.3,
      pointStyle: 'circle',
      pointRadius: 10,
      pointHoverRadius: 15
    }]
  },options: {
    indexAxis: 'y',
  }

  });

})

document.addEventListener('turbo:load', () => {
  var el = document.getElementById('mycountries');
  if (!el) return;
  destroyIfExists('mycountries');
  var ctx = el.getContext('2d');
  charts['mycountries'] = new Chart(ctx, {
  type: 'bar',
  data: {
    labels: JSON.parse(ctx.canvas.dataset.labels),
    datasets: [{
      label: ctx.canvas.dataset.title,
      data: JSON.parse(ctx.canvas.dataset.data),
      fill: true,
      backgroundColor: 'rgba(75, 192, 192, 0.8)',
      tension: 0.3,
      pointStyle: 'circle',
      pointRadius: 10,
      pointHoverRadius: 15
    }]
  },options: {
    indexAxis: 'y',
  }

  });
})

document.addEventListener('turbo:load', () => {
  var el = document.getElementById('mydevices');
  if (!el) return;
  destroyIfExists('mydevices');
  var ctx = el.getContext('2d');
  charts['mydevices'] = new Chart(ctx, {
  type: 'bar',
  data: {
    labels: JSON.parse(ctx.canvas.dataset.labels),
    datasets: [{
      label: ctx.canvas.dataset.title,
      data: JSON.parse(ctx.canvas.dataset.data),
      fill: true,
      backgroundColor: 'rgba(75, 192, 192, 0.8)',
      tension: 0.3,
      pointStyle: 'circle',
      pointRadius: 10,
      pointHoverRadius: 15
    }]
  },

  });
})

